import Cabrio from '@allesauto/design/graphics/Cabrio.svg';
import CarDefaultIcon from '@allesauto/design/graphics/Car-Default.svg';
import Gelaendew_PickUp from '@allesauto/design/graphics/Gelaendew_PickUp.svg';
import Kleinwagen from '@allesauto/design/graphics/Kleinwagen.svg';
import Kombi from '@allesauto/design/graphics/Kombi.svg';
import Limousine from '@allesauto/design/graphics/Limousine.svg';
import CommercialVehicle from '@allesauto/design/graphics/Nutzfahrzeug.svg';
import Sportwagen from '@allesauto/design/graphics/Sportwagen.svg';
import VanMinibus from '@allesauto/design/graphics/Van-Minibus.svg';
import translate from '@allesauto/i18n';
import { formatPrice } from '@allesauto/utils/funcs';
import Link from 'next/link';
import { useIntl } from 'react-intl';

import {
  DisplayValueTypes,
  FilterBoxCarTypesBackgroundColor,
  ICarTypesProps,
} from './types';

export default function FilterBoxCarTypesList({
  carType,
  description,
  price,
  searchUrl,
  priceFontColor = FilterBoxCarTypesBackgroundColor.GREY,
  displayValue,
  offersAmount,
}: ICarTypesProps) {
  const intl = useIntl();

  const vehicleIconList: any = {
    SUV: Gelaendew_PickUp,
    SmallCar: Kleinwagen,
    Convertible: Cabrio,
    StationWagon: Kombi,
    Limousine: Limousine,
    Van: VanMinibus,
    FamilyCar: Kombi,
    SportsCar: Sportwagen,
    CommercialVehicle: CommercialVehicle,
  };

  const VehicleIconDisplay = vehicleIconList[carType] || CarDefaultIcon;

  const baseClassNames = {
    text: `font-normal font-weight-bold text-center `,
    price: `font-weight-regular font-normal text-center `,
  };

  const classNames = {
    container: `flex flex-col items-center border-1px bg-white rounded-default no-underline p-20px border-grey30 hover:border-purple80 text-grey80 hover:text-purple80`,
    iconDispay: 'h-[50px] max-h-[50px] place-content-center text-purple80',
    description:
      'border-t-1px border-t-grey30 flex my-30px mb-10px self-stretch',
    offers: `font-weight-regular font-normal text-center `,
    WHITE: {
      text: `${baseClassNames.text} text-white`,
      price: `${baseClassNames.price} text-white`,
    },
    GREY: {
      text: `${baseClassNames.text} text-grey100`,
      price: `${baseClassNames.price} text-grey100`,
    },
    BLACK: {
      text: `${baseClassNames.text} text-black`,
      price: `${baseClassNames.price} text-black`,
    },
    PURPLE: {
      text: `${baseClassNames.text} text-purple80`,
      price: `${baseClassNames.price} text-purple80`,
    },
    GREEN: {
      text: `${baseClassNames.text} text-green60`,
      price: `${baseClassNames.price} text-green60`,
    },
  };

  function getFormattedPrice(price: number) {
    return formatPrice(intl, price, {
      withFractionDigits: true,
    });
  }

  const renderOffersAmount = () => {
    return (
      offersAmount && (
        <div
          className={classNames[priceFontColor].price}
        >{`${offersAmount} ${translate(intl, 'ui.FILTER_PAGE.OFFERS')}`}</div>
      )
    );
  };
  const renderStartingPrice = () => {
    return (
      price && (
        <div className={classNames[priceFontColor].price}>{`${translate(
          intl,
          'ui.FILTER_PAGE.PRICE_FROM'
        )} ${getFormattedPrice(price)}`}</div>
      )
    );
  };

  return (
    <Link href={searchUrl ?? '/'} className={classNames.container}>
      <div>
        <VehicleIconDisplay className={classNames.iconDispay} />
      </div>
      <div className={classNames.description}></div>
      <div>
        <div className={classNames[priceFontColor].text}>{description}</div>
        {displayValue === DisplayValueTypes.offerCount
          ? renderOffersAmount()
          : renderStartingPrice()}
      </div>
    </Link>
  );
}
